export default __webpack_public_path__ + "static/media/close_icon.9950a11e.svg";